import React, { useState, useEffect } from 'react'
import { Row } from 'antd'
import { useFormik } from 'formik'
import CreateScreen from '../../components/CreateScreen'
import CustomSelect from '../../components/CustomSelect/customSelect'
import CustomInput from '../../components/CustomInput/customInput'
import queryString from 'query-string'
import { api, request } from '../../util/handlerRequestUtil'
import './createCategory.css'
import * as yup from 'yup'

function CreateCategory(props) {
  const { id } = props.match.params
  const { alert, loading, getMessage } = props
  const isDuplicate = queryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  }).duplicate
  const formik = useFormik({
    initialValues: {},
    validationSchema: yup.object().shape({
      category: yup.number().typeError(),
      description: yup
        .string()
        .typeError()
        .required(getMessage('isRequired', getMessage('description'))),
      name: yup
        .string()
        .typeError()
        .required(getMessage('isRequired', getMessage('name')))
    }),
    onSubmit: values => {
      let formatedValues = { ...values }
      if (values.category) {
        formatedValues.categoryId = Number(values.category)
        delete formatedValues.category
      } else {
        formatedValues.categoryId = null
        formatedValues.category = null
      }

      onSubmit(formatedValues)
    }
  })
  const { setValues } = formik
  const [filters, setFilters] = useState({})

  useEffect(() => {
    requests()
  }, [])

  async function requests() {
    try {
      loading.open()
      const formatedCategory = await requestCategory()
      if (id) {
        await retrieve(id)
      }
      if (isDuplicate) {
        await retrieve(isDuplicate, true)
      }
      setFilters({
        ...formatedCategory
      })
    } catch (error) {
      console.tron.log(error)
    } finally {
      loading.close()
    }
  }

  const requestCategory = () =>
    request(
      api.listCategory({
        ignorePagination: true
      }),
      true
    ).then(({ items }) => {
      return {
        formatedCategory: items.map(item => {
          return {
            ...item,
            value: item.id,
            description: item.name
          }
        })
      }
    })

  function fields(isReadOnly) {
    return (
      <Row type="flex" justify="start">
        <CustomInput disabled={isReadOnly} field="name" rowSpan={12} context={formik} />
        <CustomInput disabled={isReadOnly} field="description" rowSpan={12} context={formik} />
        <CustomSelect
          context={formik}
          showSearch
          field="category"
          rowSpan={12}
          disabled={isReadOnly}
          values={filters.formatedCategory}
        />
      </Row>
    )
  }

  async function onSubmit(values) {
    try {
      if (id) {
        await request(api.updateCategory(id, values))
        alert.open(getMessage('successUpdateCategory'), 'success')
      } else {
        await request(api.storeCategory(values))
        alert.open(getMessage('successStoreCategory'), 'success')
      }
      props.history.push(`/Category/list`)
    } catch (error) {}
  }

  async function retrieve(id, isDuplicate) {
    try {
      const response = await request(api.retrieveCategory(id), true)
      if (isDuplicate) {
        delete response.id
      }
      setValues({
        ...response,
        category: response.categoryId
      })
    } catch (error) {}
  }

  function onClickBack() {
    props.history.push('/category/list')
  }

  return (
    <CreateScreen
      fields={fields}
      context={formik}
      editTitle={getMessage('updateCategory')}
      editTitleButton={getMessage('edit')}
      newTitle={getMessage('newCategory')}
      newTitleButton={getMessage('register')}
      onClickBack={() => onClickBack()}
      readOnlyTitle={getMessage('viewCategory')}
      readOnlyTitleButton={getMessage('edit')}
      isEdit={id}
    />
  )
}

export default CreateCategory
